import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import queryString from 'query-string';
import BaseFilter, { FilterTypeEnum } from 'components/base/BaseFilter';
import { ArrayStringData } from 'utils';
import { ADMINISTRATOR_TYPES } from 'config/CustomEnums';

const mapPropsToState = ({ storeModel, admin }) => ({
  storeList: storeModel.storeList,
  defaultSelectedStore: storeModel.selectedAllList,
  adminList: admin.allAdminList,
  defaultSelectedMerchantAdmin: admin.selectedAllList,
})
function Filter({
  storeList,
  adminList,
  defaultSelectedStore,
  defaultSelectedMerchantAdmin,
  backAction = () => { },
}) {
  const location = useLocation();

  const parsedSearch = queryString.parse(location.search);
  const searchCreationDate = parsedSearch['creation_date'] || '';

  const [targetStores, setTargetStores] = useState([]);
  const [targetMerchantAdmin, setTargetMerchantAdmin] = useState([]);
  const [creationDate, setCreationDate] = useState(searchCreationDate);

  const getStoreLabel = (item) => `[ID: ${item?.pk}] ${item?.name}`;
  const getMerchantLabel = (item) => `[ID: ${item?.pk}] ${item?.username}`;
  
  useEffect(()=> {
    const searchStores = ArrayStringData(parsedSearch["store"] || '');
    setTargetStores(
      defaultSelectedStore?.filter(item => searchStores.includes(item?.pk))?.map(item => ({
        value: item,
        label: getStoreLabel(item),
      })) || []
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultSelectedStore])

  useEffect(() => {
    const searchMerchantAdmin = ArrayStringData(parsedSearch["merchant_admin"] || '');
    setTargetMerchantAdmin(
      defaultSelectedMerchantAdmin?.filter(item => searchMerchantAdmin.includes(item?.pk))?.map(item => ({
        value: item,
        label: getMerchantLabel(item),
      })) || []
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultSelectedMerchantAdmin])

  const content = [
    {
      filterTitle: "Store",
      data: storeList,
      value: targetStores,
      setValue: setTargetStores,
      loadMoreAction: 'storeModel/getPagedStoreList',
      filterAction: 'storeModel/getPagedStoreList',
      customItem: getStoreLabel,
      component: FilterTypeEnum.multipleSelectorDropdown,
      defaultFilter: {
        searchField: "searchNameOrId"
      }
    },
    {
      filterTitle: "Merchant admin",
      data: adminList,
      value: targetMerchantAdmin,
      setValue: setTargetMerchantAdmin,
      loadMoreAction: 'admin/getPagedAdmins', 
      filterAction: 'admin/getPagedAdmins',
      customItem: (item) => `[ID: ${item?.pk}] ${item?.username}`,
      component: FilterTypeEnum.multipleSelectorDropdown,
      defaultFilter: {
        searchField: "searchNameOrId",
        adminType: ADMINISTRATOR_TYPES.MERCHANT_APP_ACCOUNT,
      }
    },
    {
      title: 'Creation date',
      value: creationDate,
      setValue: setCreationDate,
      component: FilterTypeEnum.dateRange,
    },

  ];

  return <BaseFilter content={content} backAction={backAction} />;
}

export default connect(mapPropsToState)(Filter);